import Header from '../components/Header'
import Footer from '../components/Footer'
import Hero from '../components/Hero'
import Announcements from '../components/Announcements'
import Updates from '../components/Updates'
import Services from '../components/Services'
import About from '../components/About'
import Vision from '../components/Vision'
import Membership from '../components/Membership'

const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Announcements />
        <About />
        <Services />
        <Vision />
        <Membership />
        <Updates />
      </main>
      <Footer />
    </>
  )
}

export default HomePage

